import React, { useState } from 'react';
import { Grid, Paper, Checkbox, TableContainer, Table, TableHead, TableBody, TableRow, } from "@material-ui/core";
import { useDispatch } from 'react-redux';
import CustomizedDialogs from "../../atoms/dialog";
import { StyledTableCell, StyledTableRow } from '../../atoms/table/tableStyles';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { invokePostService, handleSnackBar } from "../../../store/global/actions";


export default function ImportMessageComparisonTable({ onClose, onCompletion, data, tempDoc }) {

    const dispatch = useDispatch();
    const [isUpdating, setIsUpdating] = useState(false);
    const [fields, setFields] = useState(data ? data : []);
    const [buttonDisable, setButtonDisable] = useState(true);

    const onFieldSelect = (field, checked) => {
        let checkedFlag = false;
        let updatedFields = fields?.map(ele => {
            if (ele.id === field.id) {
                checked ? ele.selectFlag = true : ele.selectFlag = false;
            }
            if (ele.selectFlag === true) {
                checkedFlag = true;
            }
            return ele;
        });
        checkedFlag === true ? setButtonDisable(false) : setButtonDisable(true);
        setFields(updatedFields);
    }

    const onUpdate = () => {
        setIsUpdating(true);
        const fieldsToUpdate = fields.filter(field => field.selectFlag);

        dispatch(invokePostService('mergeImportedMessages', { fieldsToUpdate, tempDocId: tempDoc._id }, [])).then(result => {
            setIsUpdating(false);
            if (result.status === true) {
                dispatch(handleSnackBar({ open: true, message: result.message, severity: 'success' }));
                onCompletion();
            }

        });
    }


    const onDiscardImport = () => {
        dispatch(invokePostService('deleteTempDocument', {}, [tempDoc._id]))
        onClose();
    }


    return (
        <CustomizedDialogs
            open={true}
            title="Import Messages"
            handleClose={onDiscardImport}
            paperProps={{ style: { width: 1500, maxWidth: 1500 } }}
        >
            <Grid container direction="row" spacing={2}>
                <Grid item xs={12} style={{ overflow: 'auto', width: '600px' }}>
                    <TableContainer component={Paper} >

                        <Table aria-label="customized table" >
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align='center' style={{ width: 30 }}>#</StyledTableCell>
                                    <StyledTableCell align='center' style={{ width: 30 }}></StyledTableCell>
                                    <StyledTableCell align='center' style={{ width: 30 }}>Field Name</StyledTableCell>
                                    <StyledTableCell align='center' style={{ width: 30 }}>Message</StyledTableCell>
                                    <StyledTableCell align='center' style={{ width: 30 }}>Current data</StyledTableCell>
                                    <StyledTableCell align='center' style={{ width: 30 }}>Requested update</StyledTableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {fields?.length < 1 ?
                                    <StyledTableRow>
                                        <StyledTableCell align={'center'} colSpan={6} component="td" style={{ padding: 15 }}>
                                            No fields available.
                                        </StyledTableCell>
                                    </StyledTableRow>
                                    : fields?.map((field, index) => {

                                        return (
                                            <StyledTableRow key={index + 1}>
                                                <StyledTableCell align={'center'} component="td" style={{ width: 30 }}>
                                                    {(index + 1)}
                                                </StyledTableCell>

                                                <StyledTableCell align={'center'} component="td" style={{ width: 30 }}>
                                                    <Checkbox color='primary' checked={field.selectFlag === true} onChange={e => onFieldSelect(field, e.target.checked)} />
                                                </StyledTableCell>

                                                <StyledTableCell align={'center'} component="td" style={{ width: 30 }}>
                                                    {field.inheritedName}
                                                </StyledTableCell>
                                                <StyledTableCell align={'center'} component="td" style={{ width: 30 }}>
                                                    {field.messagename}
                                                </StyledTableCell>
                                                <StyledTableCell align={'center'} component="td" style={{ width: 30 }}>
                                                    {JSON.stringify(field.actualAtrribute)}
                                                </StyledTableCell>
                                                <StyledTableCell align={'center'} component="td" style={{ width: 30 }}>
                                                    {JSON.stringify(field.newAttribute)}
                                                </StyledTableCell>

                                            </StyledTableRow>

                                        )
                                    })}
                            </TableBody>
                        </Table>

                    </TableContainer>
                </Grid>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                    <UpdateCancel updateDisable={isUpdating || buttonDisable} content={isUpdating ? 'Updating..' : 'Update'} onUpdate={onUpdate} onCancel={onDiscardImport} />
                </Grid>
            </Grid>
        </CustomizedDialogs>
    )
}